import short from "short-uuid";

//Get UUID
export const getUUID = () => {
  return short.uuid();
};

export const loadStatus = {
  success: "success",
  error: "error",
  loading: "loading",
};

export const getRandomColor = () => {
  const colors = [
    `bg-teal-600`,
    `bg-blue-600`,
    `bg-indigo-600`,
    "bg-red-600",
    `bg-orange-600`,
    `bg-yellow-600`,
    `bg-purple-600`,
    `bg-pink-600`,
    `bg-green-600`,
    `bg-stone-600`,
    `bg-neutral-600`,
    `bg-zinc-600`,
  ];
  const random = Math.floor(Math.random() * colors.length);
  return colors[random].trim();
};

export const getRandomBackgroundColor = () => {
  const colors = [
    `bg-teal-600`,
    `bg-blue-600`,
    `bg-indigo-600`,
    "bg-red-600",
    `bg-orange-600`,
    `bg-yellow-600`,
    `bg-purple-600`,
    `bg-pink-600`,
    `bg-green-600`,
    `bg-stone-600`,
    `bg-neutral-600`,
    `bg-zinc-600`,
  ];
  const random = Math.floor(Math.random() * colors.length);
  return colors[random].trim();
};

//Text Color
export const getRandomTextColor = () => {
  const colors = [
    `text-slate-500`,
    "text-red-500",
    `text-orange-500`,
    `text-amber-500`,
    `text-yellow-500`,
    `text-lime-500`,
    `text-green-500`,
    `text-emerald-500`,
    `text-teal-500`,
    `text-cyan-500`,
    `text-sky-500`,
    `text-blue-500`,
    `text-purple-500`,
    `text-fuchsia-500`,
    `text-pink-500`,
    `text-rose-500`,
    // `text-neutral-500`,
    // `text-indigo-500`,
    // `text-stone-500`,
    // `text-zinc-500`,
  ];
  const random = Math.floor(Math.random() * colors.length);
  return colors[random].trim();
};

//Convert permissions to array of obgects
export const convertPermissions = (data) => {
  const uniqueResources = {};

  data.forEach((item) => {
    if (!uniqueResources[item.resource]) {
      uniqueResources[item.resource] = {
        name: item.resource,
        label: item.name || item.name,
      };
    }
  });

  return Object.values(uniqueResources);
};

//Convert permissions back to arrays
export const mergeArraysByNameAndAction = (arrayWithIds, arrayWithoutIds) => {
  return arrayWithoutIds.map((itemWithoutId) => {
    const matchingItem = arrayWithIds.find(
      (itemWithId) =>
        itemWithId.resource === itemWithoutId.resource &&
        itemWithId.action === itemWithoutId.action
    );

    // If a matching item is found, add the id to the new object
    if (matchingItem) {
      return { ...itemWithoutId, id: matchingItem.id };
    }

    // If no matching item is found, return the object without id
    return itemWithoutId;
  });
};

//Group permissions resource
export const groupByResource = (initialPermissions, permissions) => {
  const actions = ["read", "create", "update", "delete"];
  const initialStructure = initialPermissions.reduce((acc, resource) => {
    acc[resource.name] = actions.reduce((actionAcc, action) => {
      actionAcc[action] = false;
      return actionAcc;
    }, {});
    return acc;
  }, {});

  return permissions.reduce((acc, curr) => {
    const { resource, action } = curr;
    if (!acc[resource]) acc[resource] = {};
    acc[resource][action] = true;
    return acc;
  }, initialStructure);
};

//Convert to original array
export const convertToOriginalArrayFormat = (data) => {
  const result = [];

  Object.keys(data).forEach((resource) => {
    Object.keys(data[resource]).forEach((action) => {
      if (data[resource][action]) {
        result.push({ resource, action });
      }
    });
  });

  return result;
};

//Check the authorized permission before giving access
export const isAuth = (permissions, resource, action) => {
  if (!permissions) {
    return false;
  } else
    return permissions.some(
      (perm) => perm.action === action && perm.resource === resource
    );
};

//
export const isRolePresent = (roles, role) => {
  if (!roles) {
    return false;
  }
  return roles.some((item) => item.name.toLowerCase() === role);
};

//Find role by id and compare it with role name and returnn true or false
export const findRoleById = (items, id, role) => {
  return role === items.find((item) => item.id === id).name.toLowerCase();
};

//
export const isRoleIdPresent = (roles, id) => {
  if (!roles) {
    return false;
  }
  return roles.some((item) => item.id === id);
};

//Select upcoming as the default state
export const getDefaultStatus = (projectStatuses) => {
  if (projectStatuses.length <= 0) {
    return "";
  }
  return projectStatuses.find((item) => item.name.toLowerCase() === "request")
    .id;
};

//Get Todays Date
export const getFirstDate = () => {
  const today = new Date();
  const firstDayOfYear = new Date(today.getFullYear(), 0, 1); // January 1st of the current year
  return firstDayOfYear.toISOString().split("T")[0]; // Format as YYYY-MM-DD
};

//Get Todays Date
export const getTodayDate = () => {
  const today = new Date();
  return new Date(today).toISOString().split("T")[0];
};

//Get date from today to specifiesd nnumber of days
export const getDate = (days) => {
  const today = new Date();
  const date = today.setDate(today.getDate() + days);
  return new Date(date).toISOString().split("T")[0];
};

//Format date to readable string
export const formatDate = (date) => {
  return new Date(date).toISOString().split("T")[0];
};

//Find Country
export const findCountryByName = (countries, country) => {
  if (!countries) return {};
  return countries.find((item) => item.nice_name === country);
};

//Capitalize first
export const capitalizeFirst = (s) =>
  (s && s[0].toUpperCase() + s.slice(1)) || "";

//Sum Array
export const sumArray = (array) => {
  if (!array) {
    return 0;
  }

  let newArr = array;

  if (!array && array.length <= 0) {
    return 0;
  }
  if (array instanceof Array) {
    newArr = array;
  } else {
    newArr = [];
  }

  return formatCurrency(
    newArr.reduce((acc, item) => acc + Number(item.amount), 0)
  );
};

//Format Currenciy
export const formatCurrency = (amount) => {
  if (!amount) return "0.00";

  // Convert the number to a string in currency format with commas and two decimal points
  return Number(amount).toLocaleString("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

//Calculate Compare budget
export const compareBudget = (income, expenses) => {
  const result = income - expenses;

  // If result is negative, show it in brackets without negative sign
  if (result < 0) {
    return `(${formatCurrency(-result)})`; // Remove negative sign, display in brackets
  } else {
    return formatCurrency(result); // Regular format for positive values
  }
};
